import React from "react"
import { Link } from "gatsby"

const LeyMethodLink = () => {
  return (
    <>
    {/*//////////////////////////////* ↓コンテンツ02 * //////////////////////////////*/}
      <div className="contents contents_wrap">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}
            <div className="wrap_box w670">
              <div className="inner_title">
                <div className="inner_title_in">
                  <h4 className="maintitle"><span>Key Method</span></h4>
                  <p className="subtitle"><span>大事にしているメソッド</span></p>
                </div>
              </div>
              <div className="cnt_box">
                <div className="flex_wrap step_wrap scroll_x">
                  <div className="flex_contents">
                    <div className="step_box"><Link to="/key-method/connecting-leader"><p>コネクティングリーダー</p><span>未来と世界を結ぶ新たなリーダー</span></Link></div>
                  </div>
                  <div className="flex_contents">
                    <div className="step_box"><Link to="/key-method/organizational-feeling"><p>組織感情</p><span>組織感情をマネジメントする</span></Link></div>
                  </div>
                  <div className="flex_contents">
                    <div className="step_box"><Link to="/key-method/engineering-for-feeling"><p>感情エンジニアリング</p><span>やってみたいという感情を引き出す</span></Link></div>
                  </div>
                  <div className="flex_contents">
                    <div className="step_box"><Link to="/key-method/reflection-and-dialog"><p>内省と対話</p><span>自分を知り、他人を知る</span></Link></div>
                  </div>
                  <div className="flex_contents">
                    <div className="step_box m_btm0"><Link to="/key-method/connection-power"><p>つながり力</p><span>一人ひとりがつながる力</span></Link></div>
                  </div>
                  <div className="flex_contents">
                    <div className="step_box m_btm0"><Link to="/key-method/communityship"><p>コミュニティシップ経営</p><span>みんながリーダー、みんながメンバー</span></Link></div>
                  </div>
                </div>
              </div>
            </div>
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}
    {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
    </>
  )
}

export default LeyMethodLink